import { Modal } from "antd"
import PayInvoice from "./PayInvoice"
import { toMarkStatementPaidManuallyRequest } from "./payInvoiceModel"
import { useMarkStatementPaidManuallyMutation, useStatementPaymentStatusQuery, useStatementQuery } from "../../../domain/invoicing/statementsQueries"
import { usePayDocument } from "./usePayDocument"

export type Props = {
  isOpen: boolean
  onClose: () => void
  statementId: string
  customerId: number
  statementTotal: number
}

const StatementPaymentModal = ({ isOpen, onClose, statementId, customerId, statementTotal }: Props) => {
  const paymentStatusQuery = useStatementPaymentStatusQuery(statementId, { disabled: !isOpen })
  const statementQuery = useStatementQuery(statementId, { disabled: !isOpen })
  const markPaidManuallyMutation = useMarkStatementPaidManuallyMutation()

  const pay = usePayDocument({
    isOpen,
    onClose,
    customerId,
    documentLabel: 'Statement',
    paymentStatusQuery,
    markPaidManuallyMutation,
    buildMarkPaidRequest: (state) => toMarkStatementPaidManuallyRequest(statementId, state)
  })

  return <Modal
    open={isOpen}
    okText="Submit"
    okButtonProps={{ disabled: pay.submitDisabled, loading: pay.isSubmitting }}
    onOk={pay.handleSubmit}
    onCancel={onClose}
    title="Pay Statement"
    width={800}
  >
    {isOpen && <PayInvoice
      invoiceTotal={statementTotal}
      documentLabel="Statement"
      isLoading={pay.isLoading || statementQuery.isLoading}
      isError={pay.isError}
      status={pay.paymentStatus}
      paymentMethods={pay.paymentMethods}
      payInvoiceState={pay.payState}
      setPayInvoiceState={pay.setPayState}
      paymentPageUrl={statementQuery.data?.paymentPageUrl ?? ''}
    />}
  </Modal>
}

export default StatementPaymentModal
